import { Button } from 'flowbite-react';
import icon from '../../../assets/Featured icon (1).png';
import CustomInput from '../../../components/CustomInputs/CustomInput';
import { useState } from 'react';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';

interface AddCustomersModalProps {
    onClose: () => void;
    onCustomerAdded: () => void;
}
const AddCustomersModal = ({ onClose, onCustomerAdded }: AddCustomersModalProps) => {
    const [inputs, setInputs] = useState({
        firstName: "",
        email: "",
        lastName: "",
        mobile: "+234",
    });

    const disableFunction = () => {
        return !(inputs.firstName && inputs.email && inputs.lastName && inputs.mobile);
    };

    const updateProps = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        const inputName = event.target.name;
        setInputs((prevState: any) => {
            return {
                ...prevState,
                [inputName]: newValue,
            };
        });
    };

    let disabled = disableFunction();

    const createNewCustomer = async () => {
        try {
            const data: any = await client.post("/subsidiary/customer/create", inputs);

            const message = data?.data?.message;
            showToast(message, "success");
            onCustomerAdded(); // Call the function to refresh the data
            onClose(); // Close the modal
        } catch (error: any) {
            const { message } = error?.response?.data;
            console.error(error);
            showToast(message, "error");
        }
    };

    return (
        <div>
            <div>
                <img src={icon} className='my-3' />
                <div className='my-3'>
                    <p className='text-xl font-bold'>Add New Customers</p>
                    <p className='text-sm'>Kindly fill in information needed</p>
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                <CustomInput label='First name' name='firstName' value={inputs.firstName} onChange={updateProps} />
                <CustomInput label='Last name' name='lastName' value={inputs.lastName} onChange={updateProps} />
                <CustomInput label='Email address' name='email' value={inputs.email} onChange={updateProps} />
                <CustomInput label='Phone number' name='mobile' value={inputs.mobile} onChange={updateProps} />
            </div>
            <div className='flex gap-4'>
                <Button className='w-1/4' outline onClick={onClose}>Cancel</Button>
                <Button 
                    className={`w-3/4 text-black ${disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-custom-button-green'}`} 
                    disabled={disabled} onClick={createNewCustomer}
                >
                    Create a new Customer
                </Button>
            </div>
        </div>
    );
};

export default AddCustomersModal;
